import PropTypes from 'prop-types';
import { Box, Tab, Tabs as MuiTabs, Typography } from '@mui/material';

const styles = {
  tabs: ({ palette, breakpoints }, showTabsButtons) => ({
    borderRadius: '16px',
    border: `2px solid ${palette.primary.main}`,
    '.MuiTabs-indicator': {
      display: 'none',
    },
    '.MuiTabs-flexContainer': {
      height: 44,

      [breakpoints.up('md')]: {
        height: 64,
      },
    },
    ...(!showTabsButtons && { display: 'none' }),
  }),
  tabButton: ({ palette }, isActive) => ({
    backgroundColor: isActive ? palette.primary.main : palette.common.white,
    padding: '7px 34px',
    minHeight: 44,
    transition: 'background-color 0.3s',
    '&:first-of-type': { borderRadius: '0 16px 16px 0' },
    '&:last-of-type': { borderRadius: '16px 0 0 16px' },
  }),
  tabPanel: ({ breakpoints }) => ({
    paddingTop: 2,
    [breakpoints.up('md')]: {
      paddingTop: 6,
    },
  }),
};

const getTabId = (tabName) => tabName.toLowerCase().replace(/\s+/g, '-');

const ProjectsTabs = ({ showTabsButtons, tabsData, activeTab, setActiveTab, customStyles = {} }) => {
  return (
    <>
      <MuiTabs
        variant="fullWidth"
        value={activeTab}
        onChange={(event, value) => setActiveTab(value)}
        aria-label="Projects tabs"
        sx={[(theme) => styles.tabs(theme, showTabsButtons), customStyles.tabButton]}
      >
        {tabsData.map(({ tabName }) => {
          const tabId = getTabId(tabName);

          return (
            <Tab
              key={tabName}
              value={tabName}
              label={
                <Typography
                  variant="subtitle1-bold"
                  component="span"
                  color={activeTab === tabName ? 'text.secondary' : 'primary'}
                >
                  {tabName}
                </Typography>
              }
              id={`projects-tab-${tabId}`}
              aria-controls={`projects-tabpanel-${tabId}`}
              sx={(theme) => styles.tabButton(theme, activeTab === tabName)}
            />
          );
        })}
      </MuiTabs>

      {tabsData.map(({ tabName, content }) => {
        const tabId = getTabId(tabName);

        return (
          <Box
            key={tabName}
            role="tabpanel"
            hidden={activeTab !== tabName}
            id={`projects-tabpanel-${tabId}`}
            aria-labelledby={`projects-tab-${tabId}`}
            sx={[styles.tabPanel, customStyles.tabPanel]}
          >
            {activeTab === tabName && content}
          </Box>
        );
      })}
    </>
  );
};

ProjectsTabs.propTypes = {
  showTabsButtons: PropTypes.bool.isRequired,
  tabsData: PropTypes.arrayOf(
    PropTypes.shape({
      tabName: PropTypes.string,
      content: PropTypes.node,
    }),
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  customStyles: PropTypes.shape({
    tabButton: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    tabPanel: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  }),
};
export default ProjectsTabs;
